import React from 'react';
import CardIcon from './CardIcon';

const PaymentMethodItem = ({ method, onSetDefault, onDelete }) => {
    const actionButtonStyle = {
        border: '1px solid #dee2e6',
        backgroundColor: 'white',
        width: '40px',
        height: '40px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '5px',
        cursor: 'pointer'
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-8">
                    <div className="d-flex align-items-center">
                        <CardIcon type={method.type} />
                        <div>
                            <div>
                                <span>•••• {method.last4}</span>
                                <span className="ms-2 text-muted">Expires {method.expiryDate}</span>
                                {method.isDefault && (
                                    <span className="ms-2 badge bg-success">Default</span>
                                )}
                            </div>
                            <div className="text-muted mt-1">{method.cardholderName}</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="d-flex justify-content-end">
                        {!method.isDefault && (
                            <button
                                onClick={onSetDefault}
                                style={actionButtonStyle}
                                className="btn"
                                aria-label="Set as default payment method"
                            >
                                ✓
                            </button>
                        )}

                        <button
                            onClick={onDelete}
                            style={actionButtonStyle}
                            className="btn"
                            aria-label="Delete payment method"
                        >
                            🗑️
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentMethodItem;